import axios from 'axios';
import { auth } from './firebase';

const getBaseURL = (): string => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:8000`;
};

const apiClient = axios.create({
  baseURL: getBaseURL(),
  headers: { 'Content-Type': 'application/json' },
});

// Attach Firebase JWT to every request
apiClient.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Surface backend error messages
apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err.response?.data?.detail;
    const message = Array.isArray(detail)
      ? detail.map((d: any) => d.msg ?? JSON.stringify(d)).join('; ')
      : (detail || err.message || 'An error occurred');
    return Promise.reject(new Error(message));
  }
);

export const fetchLiveQuotes = (tickers: string[]): Promise<Record<string, number>> => {
  if (!tickers.length) return Promise.resolve({});
  return apiClient
    .get<Record<string, number>>('/api/discover/quotes', { params: { tickers: tickers.join(',') } })
    .then((r) => r.data)
    .catch(() => ({}));
};

export default apiClient;
